export function extractErrorMessage(err: unknown): string {
  if (!err) return "";
  if (typeof err === "string") return err;
  if (typeof err === "object") {
    const anyErr = err as Record<string, unknown>;
    const data = anyErr.data as Record<string, unknown> | undefined;
    if (
      data &&
      typeof data === "object" &&
      typeof data.message === "string" &&
      data.message.length > 0
    ) {
      return data.message;
    }
    if (typeof anyErr.message === "string" && anyErr.message.length > 0) {
      return anyErr.message;
    }
    if (typeof anyErr.error === "string" && anyErr.error.length > 0) {
      return anyErr.error;
    }
    if (typeof anyErr.status === "number") {
      return `Request failed (HTTP ${anyErr.status})`;
    }
  }
  return "Request failed";
}
